import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { urlConfig } from '../../config';
import { useAppContext } from '../../context/AuthContext';
import Logo from '../common/Logo';

function RegisterPage() {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const navigate = useNavigate();
    const { setIsLoggedIn, setUserName } = useAppContext();

    const handleRegister = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${urlConfig.backendUrl}/api/auth/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ firstName, lastName, email, password })
            });
            const data = await response.json();

            if (response.ok) {
                sessionStorage.setItem('auth-token', data.authtoken);
                sessionStorage.setItem('email', data.email);
                sessionStorage.setItem('name', `${firstName} ${lastName}`);
                setIsLoggedIn(true);
                setUserName(`${firstName} ${lastName}`);
                navigate('/app');
            } else {
                setErrorMessage(data.error || 'Registration failed');
            }
        } catch (e) {
            setErrorMessage('Registration failed. Please try again.');
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-card__brand">
                    <Logo size={24} />
                    GiftLink
                </div>
                <h2>Join the community</h2>
                <p className="auth-card__subtitle">Create a free account to browse gifts and reach out to neighbors giving items away.</p>

                {errorMessage && <div className="auth-error">{errorMessage}</div>}

                <form onSubmit={handleRegister}>
                    <div className="auth-field">
                        <label htmlFor="firstName">First name</label>
                        <input id="firstName" type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
                    </div>
                    <div className="auth-field">
                        <label htmlFor="lastName">Last name</label>
                        <input id="lastName" type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
                    </div>
                    <div className="auth-field">
                        <label htmlFor="email">Email</label>
                        <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </div>
                    <div className="auth-field">
                        <label htmlFor="password">Password</label>
                        <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    </div>
                    <button type="submit" className="btn-gift btn-gift-primary">Create account</button>
                </form>

                <p className="auth-card__footer">
                    Already have an account? <Link to="/app/login">Sign in</Link>
                </p>
            </div>
        </div>
    );
}

export default RegisterPage;
